import { render } from "./ReserveConfirmView.vue?vue&type=template&id=74c947d1"
import script from "./ReserveConfirmView.vue?vue&type=script&lang=js"
export * from "./ReserveConfirmView.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2236819739/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__